var _config, _window$feConfig;

import axios from 'axios';
import { setDomainConfig, useNewDomain, envApis } from './config'; // import yxtI18n from 'yxt-i18n';

var config = (_config = {
  source: 501
}, _config[window.feConfig.apiEnv] = {
  core: window.feConfig.common.apiBaseUrl + "core/",
  media: window.feConfig.common.media,
  orgInit: window.feConfig.common.apiBaseUrl + "orginit/",
  globalApi: window.feConfig.common.scApiBaseUrl + "misc/"
}, _config);
var Api = {
  name: 'Api',
  config: config
};
var http = {};
var defaultOptions = {
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    source: config.source // add header.source

  },
  validateStatus: function validateStatus(status) {
    return status < 400;
  }
};

var getConfig = function getConfig(options) {
  options = Object.assign(defaultOptions, options);
  return options;
};

var request = {
  resolve: function resolve(config) {
    if (config.method.toLowerCase() === 'get') {
      // 给config.data赋值, 使Content-type起作用
      config.data = true;
    }

    config.headers.token = localStorage.getItem('token'); // add header.token

    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    return config;
  },
  reject: function reject(error) {
    // eslint-disable-next-line
    return Promise.reject(error);
  }
};
var response = {
  resolve: function resolve(response) {
    if (response.status === 201) {
      response.data = response.data || {};
      typeof response.data === 'object' && (response.data.Location = response.headers.location);
    }

    return response.data;
  },
  reject: function reject(error) {
    var data = error.response && error.response.data ? error.response.data : {}; // eslint-disable-next-line

    return Promise.reject(data);
  }
};
var domainKeys = envApis; // hack

var envNow = (_window$feConfig = window.feConfig) == null ? void 0 : _window$feConfig.apiEnv;

var setConfig = function setConfig(env, source) {
  var _window$feConfig2;

  if (env === void 0) {
    env = 'dev';
  }

  if (source === void 0) {
    source = config.source;
  }

  var apiEnv = (_window$feConfig2 = window.feConfig) == null ? void 0 : _window$feConfig2.apiEnv;
  var domainMap = config[apiEnv]; // hack

  envNow = apiEnv;

  if (!domainMap) {
    console.error('open data setConfig error', env, source);
    return;
  }

  domainKeys.forEach(function (key) {
    var baseURL = domainMap[key];
    if (!baseURL) return;
    var options = getConfig({
      baseURL: baseURL,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        source: config.source
      }
    });
    http[key] = axios.create(options);
    http[key].interceptors.request.use(request.resolve, request.reject);
    http[key].interceptors.response.use(response.resolve, response.reject);
    http[key].originGet = http[key].get;

    http[key].get = function (url, data, config) {
      if (data === void 0) {
        data = {};
      }

      if (config === void 0) {
        config = {};
      }

      data = data.hasOwnProperty('params') ? data : Object.assign({
        params: data
      }, config || {});
      return http[key].originGet(url, data);
    };
  });
};

Api.setConfig = function (options) {
  console.log('[INFO] Api.setConfig options:', options);
  options = typeof options === 'string' ? {
    env: options,
    source: config.source
  } : options; // 调用方需传入domain, 否则使用默认域名

  if (options.domain) {
    setDomainConfig(options.env, options.domain);
    setConfig(options.env, options.source);
  } else {
    if (!options.autoDomain) {
      setConfig(options.env, options.source);
      return;
    }

    useNewDomain(options.env, function () {
      setConfig(options.env, options.source);
    });
  } // yxtI18n.Api.setConfig(options);

};

Api.create = function (options) {
  options = Object.assign(defaultOptions, options);
  var api = axios.create(options);
  api.interceptors.request.use(request.resolve, request.reject);
  api.interceptors.response.use(response.resolve, response.reject);
  return api;
};

var getMedia = function getMedia() {
  return config[envNow].media;
};

export { http, getMedia };
export default Api;